<div class="flex flex-col gap-4 px-4">
  <div class="space-y-2">
    <div class="flex items-center">
      <div class="flex-auto block font-medium text-sm select-none">Standaard</div>
    </div>

    <div class="flex flex-col gap-1">
      @for (variable of builtinVars; track variable.key) {
        <div
          class="flex items-center gap-2 px-3 text-sm rounded-full bg-white font-medium h-8 transition-colors hover:cursor-pointer hover:bg-blue-50 overflow-hidden min-w-0"
          [matTooltip]="variable.tooltip"
          tabindex="0"
          (click)="copyVariable(variable.key)"
          (keydown.enter)="copyVariable(variable.key)"
          role="button"
        >
          <span class="var-highlight var-highlight--builtin text-xs inline-flex max-w-[50%] shrink-0">[<span class="truncate">{{ variable.key }}</span>]</span>
          <span class="min-w-0 truncate text-gray-500 text-xs flex-1">{{ variable.label }}</span>
          <button mat-icon-button class="inline-flex! size-5! p-0.5! -mr-1 shrink-0">
            <mat-icon class="text-base! leading-none!">content_copy</mat-icon>
          </button>
        </div>
      }
    </div>
  </div>

  <div class="space-y-2">
    <div class="flex items-center">
      <div class="flex-auto block font-medium text-sm select-none">Variabelen</div>
    </div>

    @if (!canReadVars()) {
      <div class="text-xs text-gray-500 px-1">
        Om variabelen te zien heb je het recht "{{ varReadLabel }}" nodig.
      </div>
    } @else if (variables().length === 0) {
      <div class="text-xs text-gray-400 px-1">Geen variabelen beschikbaar</div>
    }

    <div class="flex flex-col gap-1">
      @for (variable of variables(); track variable.key) {
        <div
          class="flex items-center gap-2 px-3 text-sm rounded-full bg-white font-medium h-8 transition-colors hover:cursor-pointer hover:bg-amber-50 overflow-hidden min-w-0"
          [matTooltip]="'[' + variable.key + '] ' + variable.value"
          tabindex="0"
          (click)="copyVariable(variable.key)"
          (keydown.enter)="copyVariable(variable.key)"
          role="button"
        >
          <span class="var-highlight text-xs inline-flex max-w-[50%] shrink-0">[<span class="truncate">{{ variable.key }}</span>]</span>
          <span class="min-w-0 truncate text-gray-500 text-xs flex-1">{{ variable.value }}</span>
          <button mat-icon-button class="inline-flex! size-5! p-0.5! -mr-1 shrink-0">
            <mat-icon class="text-base! leading-none!">content_copy</mat-icon>
          </button>
        </div>
      }
    </div>
  </div>

  @if (pendingDeletionVars().length > 0) {
    <div class="space-y-2">
      <div class="flex items-center">
        <div class="flex-auto block font-medium text-sm select-none text-red-800">
          Wordt verwijderd
        </div>
      </div>

      <div class="flex flex-col gap-1">
        @for (variable of pendingDeletionVars(); track variable.key) {
          <div
            class="flex items-center gap-2 px-3 text-sm rounded-full bg-red-50 font-medium h-8 opacity-60 cursor-default overflow-hidden min-w-0"
            [matTooltip]="'Wordt verwijderd op ' + formatDeleteAt(variable.deleteAt) + '. De tekst wordt dan vervangen door: ' + variable.value"
          >
            <span class="var-highlight var-highlight--deleted text-xs inline-flex max-w-[50%] shrink-0">[<span class="truncate">{{ variable.key }}</span>]</span>
            <span class="min-w-0 truncate text-gray-400 text-xs flex-1">{{ variable.value }}</span>
          </div>
        }
      </div>
    </div>
  }
</div>
